import "../styles.scss";
import React from "react";
import PropTypes from "prop-types";
import { getIn } from "formik";
import _ from "lodash";
import { createClassNameString } from "../../utils";
import { FormFieldError } from "../FormFieldError/FormFieldError";
import { Input } from "../../Input";

export const FormTextInput = ({
  name,
  title,
  subTitle,
  placeholder,
  customError,
  className,
  inputClassName,
  formikProps,
  // normally form fields do not error until after submission
  // because they have not been touched
  // setting this to true triggers the error after editing
  // for the first time
  triggerErrorOnChange = false,
  testId,
  // only use props to pass in native html input props
  ...props
}) => {
  const errorMessage = getIn(formikProps.errors, name);
  const isTouched = getIn(formikProps.touched, name);
  const value = _.get(formikProps.values, name);

  const handleChange = async (event) => {
    await formikProps.setFieldValue(name, event.target.value);
    if (!isTouched && triggerErrorOnChange) {
      await formikProps.setFieldTouched(name, true);
    }
  };

  return (
    <div className={createClassNameString(["FormField-container", className])}>
      {(title || subTitle) && (
        <div data-public className="FormField-header_container">
          {title && <h3 className="FormField-title">{title}</h3>}
          {subTitle && <h3 className="FormField-subTitle">{subTitle}</h3>}
        </div>
      )}

      <div>
        <Input
          value={value}
          inputClassName={createClassNameString(["FormTextInput-input", inputClassName])}
          error={isTouched && errorMessage}
          placeholder={placeholder}
          onChange={handleChange}
          ignoreEnterSubmit={true}
          testId={testId}
          {...props}
        />

        {!customError && errorMessage && isTouched && (
          <FormFieldError>{errorMessage}</FormFieldError>
        )}

        {/* lets the dev pick what is displayed below the text area */}
        {customError && customError(value, errorMessage, isTouched)}
      </div>
    </div>
  );
};

FormTextInput.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  customError: PropTypes.func,
  formikProps: PropTypes.object,
  props: PropTypes.object,
  triggerErrorOnChange: PropTypes.bool,
  testId: PropTypes.string,
};
